import { TabPanel, TabView } from "primereact/tabview";

const AIEduTabMenu = ({ items, activeIndex, onTabChange }) => {
    return (
        <>
            <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                {items.map((item, index) => (
                    <TabPanel key={index} header={item.header}>
                        {item.data}
                    </TabPanel>
                ))}
            </TabView>
        </>
    );
};

export default AIEduTabMenu;
